import type { ReportExportFormat } from '@jaf/contracts';
import { Download, FileSpreadsheet, FileText } from 'lucide-react';
import { type ReactNode, useState } from 'react';
import { Button } from '@/shared/ui/primitives/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/shared/ui/primitives/popover';

/** Botão "Exportar" com a escolha do formato: PDF (A4 paisagem) ou planilha Excel. */
export function ExportReportButton({
  onExport,
  pending,
  disabled = false,
}: {
  onExport: (format: ReportExportFormat) => void;
  pending: boolean;
  disabled?: boolean;
}): ReactNode {
  const [open, setOpen] = useState(false);
  const choose = (format: ReportExportFormat) => {
    setOpen(false);
    onExport(format);
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" disabled={disabled || pending}>
          <Download aria-hidden className="size-4" />
          {pending ? 'Exportando…' : 'Exportar'}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-60 p-1">
        <div role="menu" aria-label="Formato da exportação" className="flex flex-col">
          <Button
            role="menuitem"
            variant="ghost"
            className="justify-start"
            onClick={() => {
              choose('PDF');
            }}
          >
            <FileText aria-hidden className="size-4" />
            PDF (A4 paisagem)
          </Button>
          <Button
            role="menuitem"
            variant="ghost"
            className="justify-start"
            onClick={() => {
              choose('XLSX');
            }}
          >
            <FileSpreadsheet aria-hidden className="size-4" />
            Planilha Excel (.xlsx)
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
